import moment from 'moment' 
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
 
export default {
  extends: Line,
  mixins: [reactiveProp],
  //props: [  "options", 'labels', 'height', 'color', 'xdisplay', 'ydisplay', 'gradient', 'symbol',  ],
    props:{
        chartData:{ type : [Array, Object] },
        chartCompare:{ type : [Array, Object], default: null },
        labels:{ type : [Array, Object] },
        height:{ type : [Number] },
        color:{ type : [String] },
        symbol:{ type : [String] },
    },
    chartData: function() {
      return this.chartData;
    },
    watch: {
        'chartData':{
            deep: true,              
            handler() {
                //console.log("watcher")
                //console.log(this.chartData)
                //this._chart.update();
                this.init( this.labels, this.chartData, this.chartCompare )
            }
                
        }
    },
    methods:{
        init( columns, series, seriesCompare ){
            
            //console.log("series")
            //console.log(series)
            
            let symbol = this.symbol
            //console.log(symbol)
      
            var color, gradient;

            if( this.color == undefined ){
                color = 'rgba(62, 70, 179, 1)';
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(62, 70, 179, 0.3)')
                gradient.addColorStop(0.8, 'rgba(62, 70, 179, 0)');
            }else{
                color = '#'+this.color;
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)')
                gradient.addColorStop(0.8, 'rgba(255, 255, 255, 0)');
            }

            if( this.gradient == 'none' ){
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(255, 255, 255, 0)')
                gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
            }

            let datasets = [
                {
                    borderColor: '#3e4cb3',
                    lineTension: 0.1,
                    pointBackgroundColor: '#3e4cb3',
                    borderWidth: 1,
                    pointBorderColor: '#3e4cb3',
                    pointBorderWidth: 0.5,
                    //backgroundColor: 'rgba(62, 76, 179, 0.9)',
                    backgroundColor: 'transparent',
                    //backgroundColor: gradient,
                    label: '', //title for legend
                    data: series,
                    pointBorderColor: 'rgba(0, 0, 0, 0)',
                    pointBackgroundColor: 'rgba(0, 0, 0, 0)',
                    pointHoverBackgroundColor: '#3e4cb3',
                    pointHoverBorderColor: '#3e4cb3',
                }
            ]
                            
            if( seriesCompare.length > 0 ){
                
                color = 'rgba(0, 0, 1079, 1)';
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(0, 0, 0, 0.3)')
                gradient.addColorStop(0.8, 'rgba(0, 0, 0, 0)');
                
                let dataset2 = {
                        borderColor: '#666',
                        lineTension: 0.1,
                        pointBackgroundColor: '#666',
                        borderWidth: 1,
                        pointBorderColor: '#666',
                        pointBorderWidth: 0.5,
                        //backgroundColor: 'rgba(62, 76, 179, 0.3)',
                        backgroundColor: 'transparent',
                        //backgroundColor: gradient,
                        label: '', //title for legend
                        data: seriesCompare,
                        pointBorderColor: 'rgba(0, 0, 0, 0)',
                        pointBackgroundColor: 'rgba(0, 0, 0, 0)',
                        pointHoverBackgroundColor: '#1a1a1a',
                        pointHoverBorderColor: '#1a1a1a',
                    }
                
                datasets.push( dataset2 )
            }
            
            let chartData = { labels: columns, datasets: datasets }

            //console.log( this.options )
            let options = {
                responsive: true, 
                maintainAspectRatio: false, 
                legend: {
                    display: false,
                    position: "bottom",
                    align: 'end',
                    fullWidth: false,
                    labels: {
                        boxWidth: 10,
                        fillStyle: "Color",
                        fontSize: 11
                    }
                }, 
                scales: {
                  xAxes: [{
                    gridLines: {
                        display:true,
                        drawBorder: true,
                        //offsetGridLines : true
                    }, 
                    ticks: {
                        fontColor: '#000',
                        autoSkip: true,
                        maxTicksLimit: 1,
                        maxRotation: 0,
                        minRotation: 0,
                        //spadding: -25,
                        mirror:true
                    },
                  }],

                  yAxes: [{
                    gridLines: {
                        display:false
                    },  
                    ticks: {
                        display: false,
                        fontColor: '#000',
                        beginAtZero: true,
                    }, 
                  }],
                },
                tooltips: {

                    mode: 'index',
                    intersect: false,
                    displayColors: false,
                    /*
                    callbacks: {
                        title: function(tooltipItem, data) {

                            console.log( data['labels'][tooltipItem[0]['index']] )
                            //return moment( data['labels'][tooltipItem[0]['index']] ).format( 'HH:00' )
                            return data['labels'][tooltipItem[0]['index']]
                        },
                        label: function(tooltipItem, data) {
                            //console.log(data)
                            //console.log( data['datasets'][0]['data'][tooltipItem['index']] )
                            let series1 =  data['datasets'][0]['data'][tooltipItem['index']];
                            let result = symbol+' '+series1
                            
                            if( data['datasets'].length == 2 ){
                                let series2 =  data['datasets'][1]['data'][tooltipItem['index']];
                                //result += ' Today vs ' + symbol+' '+series2 + ' Yesterday'
                            }
                            
                            //result = result.toString()

                            return result
                        },
                        afterLabel: function(tooltipItem, data) {
                            var dataset = data['datasets'][0];
                            //console.log(dataset)
                            //var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
                            //return '(' + percent + '%)';
                        }
                    },
                    */
                    callbacks: {
                        label: function (t, d) {
                            /*
                            if (t.datasetIndex === 0) {
                                return '$' + t.yLabel.toFixed(2);
                            } else if (t.datasetIndex === 1) {
                                if (t.yLabel.toString().length === 9) {
                                    return Math.round(+t.yLabel.toString().replace(/(\d{3})(.*)/, '$1.$2')) + 'M';
                                } else return Math.round(+t.yLabel.toString().replace(/(\d{2})(.*)/, '$1.$2')) + 'M';
                            }
                            */
                            //console.log( d.datasets )
                            //console.log( d.datasets.length )
                            let day = '';
                            if( d.datasets.length == 2 ){
                                if( t.datasetIndex == 0 ){
                                    day ='Today: '
                                }else{
                                    day = 'Yesterday: '
                                }
                            }
                            
                            //console.log( t.yLabel )
                            let formattedValue = t.yLabel.toFixed(2)
                            if( symbol == '' ){
                                formattedValue = t.yLabel.toFixed(0)
                            }
                            formattedValue = formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            
                            return day + " " + symbol + formattedValue
                        }
                    },


                },
                layout: {
                    padding: { top: 10 }
                }

            }
            
            this.renderChart( chartData, options )
            
        },
    },
  mounted () {
      
      this.init( this.labels, this.chartData, this.chartCompare )
      
  },

}



// WEBPACK FOOTER //
// ./src/components/charts/lineChart.js